import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryTranslations = combine(i18n.$t, ({ t }) => ({
  libraryTitle: t('my_list'),
  liveChannels: t('live_channels'),
  movies: t('movies'),
  shows: t('series'),
  events: t('event_other'),
}))
